module.exports = __webpack_public_path__ + "static/media/shop-floor.c8a06d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop-floor.jpg
// module id = 563
// module chunks = 0